import React from "react";
import ExpenseTracker from "../../../components/calculators/ExpenseTracker";
import SEO from "../../../components/seo";
import { ToastProvider } from "react-toast-notifications";

const ExpenseTrackerPage = () => {
  return (
    <ToastProvider placement="bottom-center">
      <SEO
        title="Quick and Simple Budgeting App"
        description="Create budgets, add expenses and income. Everything without registration, save data locally, export if needed."
      />
      <div id="modal-container" />
      <ExpenseTracker />
    </ToastProvider>
  );
};

export default ExpenseTrackerPage;
